export default {
  "id": "8902",
  "applicableYears": [
    2013,
    2014,
    2015,
    2016,
    2017
  ],
  "name": "ThreadingByIris",
  "cashflowData": [
    {
      "source": "keyed",
      "period": "tax",
      "category": "gross_revenue",
      "year": 2013,
      "data": 129048,
      "resourceType": "Business",
      "createdAt": 1519865093,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "gross_revenue",
      "year": 2014,
      "data": 912830,
      "resourceType": "Business",
      "createdAt": 1519865096,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "gross_revenue",
      "year": 2015,
      "data": 1283,
      "resourceType": "Business",
      "createdAt": 1519328478,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "gross_revenue",
      "year": 2016,
      "data": 12830,
      "resourceType": "Business",
      "createdAt": 1519865110,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "interim",
      "category": "gross_revenue",
      "year": 2017,
      "data": -12830,
      "resourceType": "Business",
      "createdAt": 1519948770,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "interim",
      "category": "cogs",
      "year": 2017,
      "data": 1283,
      "resourceType": "Business",
      "createdAt": 1519328512,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "cogs",
      "year": 2013,
      "data": 20305,
      "resourceType": "Business",
      "createdAt": 1519936935,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "cogs",
      "year": 2014,
      "data": 12830,
      "resourceType": "Business",
      "createdAt": 1519935691,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "cogs",
      "year": 2015,
      "data": 1283,
      "resourceType": "Business",
      "createdAt": 1519328526,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "cogs",
      "year": 2016,
      "data": 1283,
      "resourceType": "Business",
      "createdAt": 1519328528,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "opex",
      "year": 2016,
      "data": 1283,
      "resourceType": "Business",
      "createdAt": 1519328685,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "opex",
      "year": 2013,
      "data": 128030,
      "resourceType": "Business",
      "createdAt": 1519942222,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "opex",
      "year": 2014,
      "data": 12830,
      "resourceType": "Business",
      "createdAt": 1519935574,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "opex",
      "year": 2015,
      "data": 120830,
      "resourceType": "Business",
      "createdAt": 1519937135,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "opex",
      "year": 2017,
      "data": 1283000,
      "resourceType": "Business",
      "createdAt": 1519328753,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "interest_expense",
      "year": 2013,
      "data": 500,
      "resourceType": "Business",
      "createdAt": 1519422016,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "interest_expense",
      "year": 2014,
      "data": 2000,
      "resourceType": "Business",
      "createdAt": 1519428713,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "depreciation",
      "year": 2013,
      "data": 56780,
      "resourceType": "Business",
      "createdAt": 1519424706,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "depreciation",
      "year": 2014,
      "data": 45679,
      "resourceType": "Business",
      "createdAt": 1519946387,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "business_use_of_home_expense",
      "year": 2013,
      "data": 234567,
      "resourceType": "Business",
      "createdAt": 1519424386,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "business_use_of_home_expense",
      "year": 2014,
      "data": 3325,
      "resourceType": "Business",
      "createdAt": 1519424430,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "business_use_of_home_expense",
      "year": 2015,
      "data": 3323,
      "resourceType": "Business",
      "createdAt": 1519424448,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "interest_expense",
      "year": 2015,
      "data": 20000,
      "resourceType": "Business",
      "createdAt": 1519430857,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "business_dscr",
      "year": 2015,
      "data": -12830,
      "resourceType": "Business",
      "createdAt": 1519431530,
      "__typename": "CashflowDatum"
    },
    {
      "source": "keyed",
      "period": "tax",
      "category": "business_use_of_home_expense",
      "year": 2017,
      "data": 19,
      "resourceType": "Business",
      "createdAt": 1519765790,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "net_profit",
      "year": 2013,
      "data": -19287,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "net_profit",
      "year": 2014,
      "data": 887170,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "net_profit",
      "year": 2015,
      "data": -120830,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "net_profit",
      "year": 2016,
      "data": 10264,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "interim",
      "category": "net_profit",
      "year": 2017,
      "data": -1297113,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "cash_available_for_debt_service",
      "year": 2013,
      "data": 272560,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "cash_available_for_debt_service",
      "year": 2014,
      "data": 938174,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "cash_available_for_debt_service",
      "year": 2015,
      "data": -97507,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "cash_available_for_debt_service",
      "year": 2017,
      "data": -1297094,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "cash_available_for_debt_service",
      "year": 2016,
      "data": 10264,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "ebitda",
      "year": 2013,
      "data": 272560,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "ebitda",
      "year": 2014,
      "data": 938174,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "ebitda",
      "year": 2015,
      "data": -97507,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "ebitda",
      "year": 2017,
      "data": -1297094,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "ebitda",
      "year": 2016,
      "data": 10264,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "existing_business_loan_payments",
      "year": 2013,
      "data": 1464,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "existing_business_loan_payments",
      "year": 2014,
      "data": 1464,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "existing_business_loan_payments",
      "year": 2015,
      "data": 1464,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "existing_business_loan_payments",
      "year": 2016,
      "data": 1464,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "existing_business_loan_payments",
      "year": 2017,
      "data": 1464,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "proposed_smartbiz_loan_payments",
      "year": 2013,
      "data": 13933,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "proposed_smartbiz_loan_payments",
      "year": 2014,
      "data": 13933,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "proposed_smartbiz_loan_payments",
      "year": 2015,
      "data": 13933,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "proposed_smartbiz_loan_payments",
      "year": 2016,
      "data": 13933,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "proposed_smartbiz_loan_payments",
      "year": 2017,
      "data": 13933,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_proposed_smartbiz_loan_payments",
      "year": 2013,
      "data": 15201,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_proposed_smartbiz_loan_payments",
      "year": 2014,
      "data": 15201,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_proposed_smartbiz_loan_payments",
      "year": 2015,
      "data": 15201,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_proposed_smartbiz_loan_payments",
      "year": 2016,
      "data": 15201,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_proposed_smartbiz_loan_payments",
      "year": 2017,
      "data": 15201,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "total_business_loan_payments",
      "year": 2013,
      "data": 15397,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "total_business_loan_payments",
      "year": 2014,
      "data": 15397,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "total_business_loan_payments",
      "year": 2015,
      "data": 15397,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "total_business_loan_payments",
      "year": 2016,
      "data": 15397,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "total_business_loan_payments",
      "year": 2017,
      "data": 15397,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_total_business_loan_payments",
      "year": 2013,
      "data": 16665,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_total_business_loan_payments",
      "year": 2014,
      "data": 16665,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_total_business_loan_payments",
      "year": 2015,
      "data": 16665,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_total_business_loan_payments",
      "year": 2016,
      "data": 16665,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_total_business_loan_payments",
      "year": 2017,
      "data": 16665,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "business_dscr",
      "year": 2013,
      "data": 17.7,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "business_dscr",
      "year": 2014,
      "data": 60.93,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "business_dscr",
      "year": 2015,
      "data": -6.33,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "business_dscr",
      "year": 2016,
      "data": 0.67,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "business_dscr",
      "year": 2017,
      "data": -84.24,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_business_dscr",
      "year": 2013,
      "data": 16.36,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_business_dscr",
      "year": 2014,
      "data": 56.3,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_business_dscr",
      "year": 2015,
      "data": -5.85,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_business_dscr",
      "year": 2016,
      "data": 0.62,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    },
    {
      "source": "derived",
      "period": "tax",
      "category": "stressed_business_dscr",
      "year": 2017,
      "data": -77.83,
      "resourceType": "Business",
      "createdAt": 1520294497,
      "__typename": "CashflowDatum"
    }
  ],
  "financialReviewSegments": [
    {
      "title": "Net Profit & Loss",
      "key": "net_profit_loss",
      "categories": [
        {
          "key": "gross_revenue",
          "title": "Gross Revenue",
          "required": true,
          "derived": false,
          "__typename": "FinancialReviewCategory"
        },
        {
          "key": "cogs",
          "title": "Cost of Goods Sold",
          "required": true,
          "derived": false,
          "__typename": "FinancialReviewCategory"
        },
        {
          "key": "opex",
          "title": "Operating Expenses",
          "required": true,
          "derived": false,
          "__typename": "FinancialReviewCategory"
        },
        {
          "key": "net_profit",
          "title": "Net Profit",
          "required": true,
          "derived": true,
          "__typename": "FinancialReviewCategory"
        }
      ],
      "__typename": "FinancialReviewSegment"
    },
    {
      "title": "Cash Available for Debt Service",
      "key": "cash_available_for_debt_service",
      "categories": [
        {
          "key": "interest_expense",
          "title": "Interest Expense",
          "required": true,
          "derived": false,
          "__typename": "FinancialReviewCategory"
        },
        {
          "key": "depreciation",
          "title": "Depreciation",
          "required": true,
          "derived": false,
          "__typename": "FinancialReviewCategory"
        },
        {
          "key": "officer_comp",
          "title": "Officer Compensation",
          "required": true,
          "derived": false,
          "__typename": "FinancialReviewCategory"
        },
        {
          "key": "business_use_of_home_expense",
          "title": "Business Use of Home Expense",
          "required": true,
          "derived": false,
          "__typename": "FinancialReviewCategory"
        },
        {
          "key": "cash_available_for_debt_service",
          "title": "Cash Available for Debt Service",
          "required": true,
          "derived": true,
          "__typename": "FinancialReviewCategory"
        }
      ],
      "__typename": "FinancialReviewSegment"
    },
    {
      "title": "Business Debt",
      "key": "business_debt",
      "categories": [
        {
          "key": "existing_business_loan_payments",
          "title": "${Business} Loan Payments",
          "required": true,
          "derived": true,
          "__typename": "FinancialReviewCategory"
        },
        {
          "key": "proposed_smartbiz_loan_payments",
          "title": "Proposed SmartBiz Loan Payments",
          "required": true,
          "derived": true,
          "__typename": "FinancialReviewCategory"
        },
        {
          "key": "stressed_proposed_smartbiz_loan_payments",
          "title": "Stressed Proposed SmartBiz Loan Payments",
          "required": false,
          "derived": true,
          "__typename": "FinancialReviewCategory"
        },
        {
          "key": "total_business_loan_payments",
          "title": "${Business} Loan Payments",
          "required": true,
          "derived": true,
          "__typename": "FinancialReviewCategory"
        },
        {
          "key": "stressed_total_business_loan_payments",
          "title": "Stressed ${Business} Loan Payments",
          "required": false,
          "derived": true,
          "__typename": "FinancialReviewCategory"
        }
      ],
      "__typename": "FinancialReviewSegment"
    },
    {
      "title": "Business Debt Service Coverage Ratio",
      "key": "business_dscr",
      "categories": [
        {
          "key": "business_dscr",
          "title": "Business Debt Service Coverage Ratio",
          "required": true,
          "derived": true,
          "__typename": "FinancialReviewCategory"
        },
        {
          "key": "stressed_business_dscr",
          "title": "Stressed Business Debt Service Coverage Ratio",
          "required": true,
          "derived": true,
          "__typename": "FinancialReviewCategory"
        }
      ],
      "__typename": "FinancialReviewSegment"
    }
  ],
  "guarantors": [
    {
      "id": "7551",
      "name": "Iris Schedlbauer",
      "spouse": null,
      "cashflowData": [
        {
          "source": "keyed",
          "period": "tax",
          "category": "wage_income",
          "year": 2013,
          "data": 200,
          "resourceType": "Guarantor",
          "createdAt": 1519680373,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "wage_income",
          "year": 2014,
          "data": 40000,
          "resourceType": "Guarantor",
          "createdAt": 1519680424,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "wage_income",
          "year": 2015,
          "data": 20,
          "resourceType": "Guarantor",
          "createdAt": 1519680425,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "wage_income",
          "year": 2016,
          "data": 555,
          "resourceType": "Guarantor",
          "createdAt": 1519680427,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "wage_income",
          "year": 2017,
          "data": 2092,
          "resourceType": "Guarantor",
          "createdAt": 1519680429,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "guaranteed_payments",
          "year": 2013,
          "data": 4012,
          "resourceType": "Guarantor",
          "createdAt": 1519767474,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "guaranteed_payments",
          "year": 2014,
          "data": 181,
          "resourceType": "Guarantor",
          "createdAt": 1519680433,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "guaranteed_payments",
          "year": 2015,
          "data": 0,
          "resourceType": "Guarantor",
          "createdAt": 1519680434,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "guaranteed_payments",
          "year": 2016,
          "data": 0,
          "resourceType": "Guarantor",
          "createdAt": 1519680434,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "guaranteed_payments",
          "year": 2017,
          "data": 4482,
          "resourceType": "Guarantor",
          "createdAt": 1519680435,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "social_security_benefits",
          "year": 2013,
          "data": 423221,
          "resourceType": "Guarantor",
          "createdAt": 1519680439,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "social_security_benefits",
          "year": 2014,
          "data": 233321,
          "resourceType": "Guarantor",
          "createdAt": 1519680441,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "social_security_benefits",
          "year": 2015,
          "data": 58343,
          "resourceType": "Guarantor",
          "createdAt": 1519680442,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "social_security_benefits",
          "year": 2016,
          "data": 99023,
          "resourceType": "Guarantor",
          "createdAt": 1519680444,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "social_security_benefits",
          "year": 2017,
          "data": 138283,
          "resourceType": "Guarantor",
          "createdAt": 1519680447,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "rental_real_estate_expenses",
          "year": 2013,
          "data": 223838,
          "resourceType": "Guarantor",
          "createdAt": 1519680718,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "rental_real_estate_expenses",
          "year": 2014,
          "data": 28238,
          "resourceType": "Guarantor",
          "createdAt": 1519680718,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "rental_real_estate_expenses",
          "year": 2015,
          "data": 22189,
          "resourceType": "Guarantor",
          "createdAt": 1519680720,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "rental_real_estate_expenses",
          "year": 2016,
          "data": 10324,
          "resourceType": "Guarantor",
          "createdAt": 1519680724,
          "__typename": "CashflowDatum"
        },
        {
          "source": "keyed",
          "period": "tax",
          "category": "rental_real_estate_expenses",
          "year": 2017,
          "data": 23923,
          "resourceType": "Guarantor",
          "createdAt": 1519680729,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "total_income",
          "year": 2013,
          "data": 427433,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "total_income",
          "year": 2014,
          "data": 273502,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "total_income",
          "year": 2015,
          "data": 58363,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "total_income",
          "year": 2016,
          "data": 99578,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "total_income",
          "year": 2017,
          "data": 144857,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "total_expenses",
          "year": 2013,
          "data": 223838,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "total_expenses",
          "year": 2014,
          "data": 28238,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "total_expenses",
          "year": 2015,
          "data": 22189,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "total_expenses",
          "year": 2016,
          "data": 10324,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "total_expenses",
          "year": 2017,
          "data": 23923,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "net_personal_cashflow",
          "year": 2013,
          "data": 203595,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "net_personal_cashflow",
          "year": 2014,
          "data": 245264,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "net_personal_cashflow",
          "year": 2015,
          "data": 36174,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "net_personal_cashflow",
          "year": 2016,
          "data": 89254,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        },
        {
          "source": "derived",
          "period": "tax",
          "category": "net_personal_cashflow",
          "year": 2017,
          "data": 120934,
          "resourceType": "Guarantor",
          "createdAt": 1520294497,
          "__typename": "CashflowDatum"
        }
      ],
      "financialReviewSegments": [
        {
          "title": "Income",
          "key": "income",
          "categories": [
            {
              "key": "wage_income",
              "title": "Wages",
              "required": true,
              "derived": false,
              "__typename": "FinancialReviewCategory"
            },
            {
              "key": "guaranteed_payments",
              "title": "Guaranteed Payments",
              "required": true,
              "derived": false,
              "__typename": "FinancialReviewCategory"
            },
            {
              "key": "social_security_benefits",
              "title": "Social Security Benefits",
              "required": true,
              "derived": false,
              "__typename": "FinancialReviewCategory"
            },
            {
              "key": "rental_real_estate_revenue",
              "title": "Rental Real Estate Revenue",
              "required": true,
              "derived": false,
              "__typename": "FinancialReviewCategory"
            },
            {
              "key": "rental_mortgage_interest",
              "title": "Rental Real Estate Interest",
              "required": true,
              "derived": false,
              "__typename": "FinancialReviewCategory"
            },
            {
              "key": "rental_real_estate_depreciation",
              "title": "Rental Real Estate Depreciation",
              "required": true,
              "derived": false,
              "__typename": "FinancialReviewCategory"
            },
            {
              "key": "other_business_cashflow",
              "title": "Schedule C Cash Flow (side-business)",
              "required": true,
              "derived": false,
              "__typename": "FinancialReviewCategory"
            },
            {
              "key": "pensions_and_annuities",
              "title": "Pensions (recurring)",
              "required": true,
              "derived": false,
              "__typename": "FinancialReviewCategory"
            },
            {
              "key": "ira_distributions",
              "title": "IRA Distributions (recurring)",
              "required": true,
              "derived": false,
              "__typename": "FinancialReviewCategory"
            },
            {
              "key": "total_income",
              "title": "Total Income",
              "required": true,
              "derived": true,
              "__typename": "FinancialReviewCategory"
            }
          ],
          "__typename": "FinancialReviewSegment"
        },
        {
          "title": "Expenses",
          "key": "expenses",
          "categories": [
            {
              "key": "federal_taxes",
              "title": "Federal Taxes",
              "required": true,
              "derived": false,
              "__typename": "FinancialReviewCategory"
            },
            {
              "key": "real_estate_taxes",
              "title": "Real Estate Taxes",
              "required": true,
              "derived": false,
              "__typename": "FinancialReviewCategory"
            },
            {
              "key": "rental_real_estate_expenses",
              "title": "Rental Real Estate Expenses",
              "required": true,
              "derived": false,
              "__typename": "FinancialReviewCategory"
            },
            {
              "key": "state_taxes",
              "title": "State Taxes",
              "required": true,
              "derived": false,
              "__typename": "FinancialReviewCategory"
            },
            {
              "key": "total_expenses",
              "title": "Total Expenses",
              "required": true,
              "derived": false,
              "__typename": "FinancialReviewCategory"
            }
          ],
          "__typename": "FinancialReviewSegment"
        },
        {
          "title": "Personal Cash Flow",
          "key": "personal_cashflow",
          "categories": [
            {
              "key": "net_personal_cashflow",
              "title": "Net Personal Cash Flow",
              "required": true,
              "derived": null,
              "__typename": "FinancialReviewCategory"
            }
          ],
          "__typename": "FinancialReviewSegment"
        },
        {
          "title": "Personal Debt",
          "key": "personal_debt",
          "categories": [
            {
              "key": "annual_personal_debt_payments",
              "title": "Total Annual Personal Debt Payments",
              "required": true,
              "derived": null,
              "__typename": "FinancialReviewCategory"
            }
          ],
          "__typename": "FinancialReviewSegment"
        }
      ],
      "__typename": "Guarantor"
    }
  ],
  "__typename": "Business"
}